import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import axiosInstance from "../utils/axiosInstance";
import PayNowForm from "./PayNowForm";
import { Alert, Button, Modal, StrokeIcon } from "./ui";

const PaymentButton = ({ file, setRefreshDetails }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasEnoughtCredits, setHasEnoughCredits] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (user.credit_balance >= file.price) {
      setHasEnoughCredits(true);
    } else {
      setHasEnoughCredits(false);
    }
  }, []);

  const handlePaymentClick = async () => {
    setIsModalOpen(true);
  };

  const confirmAndPay = async () => {
    try {
      setLoading(true);
      await axiosInstance.put(`/files/${file.id}/confirm-and-pay`);
      setRefreshDetails(true);
    } catch (error) {
      console.error("Payment failed");
    } finally {
      setLoading(false);
    }
  };

  const payable =
    file.price_status === "UNPAID" &&
    file.status !== "CANCELED" &&
    file.status !== "REFUNDED";

  return (
    <div>
      {payable && (
        <Button
          variant="success"
          onClick={handlePaymentClick}
          disabled={loading}
          className="w-full"
        >
          <StrokeIcon className="h-5 w-5">
            <rect x="3" y="6" width="18" height="12" rx="2" />
            <path d="M3 10h18" />
          </StrokeIcon>
          {hasEnoughtCredits ? "Confirm & Pay" : "Buy Credits & Pay"}
        </Button>
      )}

      {isModalOpen && !hasEnoughtCredits && (
        <Modal
          title="Not enough credits"
          tone="danger"
          onClose={() => setIsModalOpen(false)}
          footer={
            <Button variant="ghost" size="sm" onClick={() => setIsModalOpen(false)}>
              Close
            </Button>
          }
        >
          <p>Buy credits below to get this file — you need CRS {file.price}.</p>
          <div className="mt-4 flex justify-center">
            <PayNowForm userId={user.id} fileId={file.id} />
          </div>
        </Modal>
      )}

      {isModalOpen && hasEnoughtCredits && (
        <Modal
          title="Confirm payment?"
          onClose={loading ? undefined : () => setIsModalOpen(false)}
          footer={
            <>
              <Button
                variant="ghost"
                size="sm"
                disabled={loading}
                onClick={() => setIsModalOpen(false)}
              >
                No
              </Button>
              <Button size="sm" disabled={loading} onClick={() => confirmAndPay()}>
                {loading ? "Paying…" : "Yes, pay CRS " + file.price}
              </Button>
            </>
          }
        >
          <Alert tone="warning">
            <strong>Important:</strong> if your tool doesn't support checksum, please correct the
            checksum before writing.
          </Alert>
        </Modal>
      )}
    </div>
  );
};

export default PaymentButton;
